import { render, staticRenderFns } from "./BaseConfirmBtn.vue?vue&type=template&id=7ce1a6b8&scoped=true"
import script from "./BaseConfirmBtn.vue?vue&type=script&lang=js"
export * from "./BaseConfirmBtn.vue?vue&type=script&lang=js"
import style0 from "./BaseConfirmBtn.vue?vue&type=style&index=0&id=7ce1a6b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce1a6b8",
  null
  
)

/* custom blocks */
import block0 from "./BaseConfirmBtn.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports